import { ROLES } from '../constants/roles';

export interface UserLike {
  id?: string;
  name?: string;
  alias?: string;
  role?: string;
}

/** Platform god accounts are ghost users — never listed in directory UIs. */
export function isGhostUser(user: UserLike | null | undefined): boolean {
  return user?.role === ROLES.GOD;
}

export function filterListableUsers<T extends UserLike>(users: T[]): T[] {
  return users.filter((user) => !isGhostUser(user));
}
